import script from "./Advertisers.vue?vue&type=script&setup=true&lang=js"
export * from "./Advertisers.vue?vue&type=script&setup=true&lang=js"

import "./Advertisers.vue?vue&type=style&index=0&id=d35746b2&lang=scss"

const __exports__ = script;

export default __exports__